/* eslint-disable import/no-anonymous-default-export */
import apiCall from "./apiCall";

export default {

    async getStaff(data) {
       const response = await apiCall("staff/list", data);
       return response;
    },

    async registerStaff(data) {
       const response = await apiCall("staff/register", data);
       return response;
    },

    async getStaffPopulation() {
      const response = await apiCall("staff/population", []);
      return response;
    },

    async updateStaff(data) {
      const response = await apiCall("staff/update", data);
      return response;
    },
    async fetchPrefixes() {
      const response = await apiCall("list/prefixes", []);
      return response;
    },
    async fetchStaffInfo(teacher_id) {
      const data = { teacher_id };
      const response = await apiCall("staff/info", data);
      return response;
    },
    async fetchStaffSubjects(teacher_id) {
      const data = { teacher_id };
      const response = await apiCall("school/staff/teachersubject/get_teacher_subject", data);
      return response;
    },

    async assignSubject(data) {
      const response = await apiCall("school/staff/teachersubject/assign_subject", data);
      return response;
    },

    async removeStaffLoad(id) {
      const data = { id };
      const response = await apiCall("school/staff/teachersubject/remove_load", data);
      return response;
    },

    async fetchMyMarksLoad(){
      const response = await apiCall("platform/webclient/my_marks_load", []);
      return response;
    }

}